import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed top-[64px] right-0 w-full md:w-80 max-h-screen flex flex-col bg-card border-l border-border z-50 shadow-xl"
}
const _hoisted_2 = { class: "flex items-center justify-between p-4 border-b border-border" }
const _hoisted_3 = { class: "text-lg font-bold text-foreground flex items-center gap-2" }
const _hoisted_4 = { class: "flex-1 overflow-y-auto p-6 space-y-4" }
const _hoisted_5 = { class: "text-center mb-6" }
const _hoisted_6 = { class: "inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-3" }
const _hoisted_7 = { class: "text-lg font-semibold text-foreground" }
const _hoisted_8 = {
  key: 0,
  class: "text-sm text-muted-foreground"
}
const _hoisted_9 = {
  key: 0,
  class: "rounded-lg bg-orange-50 border border-orange-200 p-3"
}
const _hoisted_10 = { class: "flex items-center gap-2 text-orange-800" }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = {
  key: 0,
  class: "text-xs mt-1"
}
const _hoisted_13 = {
  key: 1,
  class: "rounded-lg bg-green-50 border border-green-200 p-3"
}
const _hoisted_14 = { class: "flex items-center gap-2 text-green-800" }
const _hoisted_15 = { class: "border-t border-border p-4 space-y-2" }

import { ref } from 'vue';
import { useAuthStore } from '@/stores/authStore';
import { useToast } from '@/composables/useToast';
import AuthModal from '@/components/auth/AuthModal.vue';
import ConfirmationModal from '@/components/shared/ConfirmationModal.vue';

interface Props {
  isOpen: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UserDropdownPanel',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close", "loginClicked", "logoutClicked"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const authStore = useAuthStore();
const { error: showError } = useToast();

// Modal states
const showAuthModal = ref(false);
const showLogoutConfirm = ref(false);

const handleClose = () => {
  emit('close');
};

const handleBackdropClick = () => {
  emit('close');
};

const handleLoginClick = () => {
  showAuthModal.value = true;
  emit('loginClicked');
};

const handleLogoutClick = () => {
  showLogoutConfirm.value = true;
  emit('logoutClicked');
};

const handleAuthSuccess = () => {
  // Auth was successful, close the dropdown panel
  handleClose();
};

const handleConfirmLogout = async () => {
  try {
    await authStore.logout();
    showLogoutConfirm.value = false;
    handleClose();
  } catch (err: any) {
    showError(err.message || 'Failed to logout. Please try again.');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AuthModal, {
      "is-open": showAuthModal.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (showAuthModal.value = false)),
      onLoginSuccess: handleAuthSuccess,
      onRegisterSuccess: handleAuthSuccess
    }, null, 8, ["is-open"]),
    _createVNode(ConfirmationModal, {
      "is-open": showLogoutConfirm.value,
      title: "Confirm Logout",
      message: "Are you sure you want to logout? You will need to login again to access your account.",
      "confirm-text": "Logout",
      "cancel-text": "Cancel",
      "is-dangerous": true,
      onConfirm: handleConfirmLogout,
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (showLogoutConfirm.value = false)),
      onClose: _cache[2] || (_cache[2] = ($event: any) => (showLogoutConfirm.value = false))
    }, null, 8, ["is-open"]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (__props.isOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fixed inset-0 bg-black/30 z-40",
                onClick: handleBackdropClick
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "slide-down" }, {
        default: _withCtx(() => [
          (__props.isOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("h2", _hoisted_3, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fal', 'circle-user'],
                      class: "text-primary"
                    }),
                    _cache[3] || (_cache[3] = _createTextVNode(" Account ", -1))
                  ]),
                  _createElementVNode("button", {
                    class: "p-2 text-muted-foreground hover:text-foreground transition-colors rounded-lg hover:bg-primary/10",
                    "aria-label": "Close account panel",
                    onClick: handleClose
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fal', 'times'],
                      class: "text-lg"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fal', 'circle-user'],
                        class: _normalizeClass(['text-3xl', _unref(authStore).headerIconColor,])
                      }, null, 8, ["class"])
                    ]),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(authStore).displayName || 'User'), 1),
                    (_unref(authStore).emailAddress)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(authStore).emailAddress), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_unref(authStore).isGuest)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: ['fas', 'info-circle'],
                            class: "text-sm"
                          }),
                          _createElementVNode("div", _hoisted_11, [
                            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "font-semibold" }, "Guest Session", -1)),
                            (_unref(authStore).formattedExpirationTime)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Expires: " + _toDisplayString(_unref(authStore).formattedExpirationTime), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(authStore).isRegisteredUser)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: ['fas', 'check-circle'],
                            class: "text-sm"
                          }),
                          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-sm font-semibold" }, "Registered User", -1))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (!_unref(authStore).isAuthenticated)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "w-full btn-primary rounded-lg px-4 py-3 font-semibold flex items-center justify-center gap-2",
                        onClick: handleLoginClick
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['fal', 'sign-in-alt'],
                          class: "text-sm"
                        }),
                        _cache[6] || (_cache[6] = _createTextVNode(" Login / Register ", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(authStore).isAuthenticated && !_unref(authStore).isGuest)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "w-full btn-outline rounded-lg px-4 py-3 font-semibold flex items-center justify-center gap-2 text-red-600 hover:text-red-700 hover:border-red-300",
                        onClick: handleLogoutClick
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['fal', 'sign-out-alt'],
                          class: "text-sm"
                        }),
                        _cache[7] || (_cache[7] = _createTextVNode(" Logout ", -1))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ], 64))
}
}

})